import { createGlobalStyle } from 'styled-components';
import theme from './theme.json';

// อ่านสีจาก theme.json ตรง ๆ ไม่ผ่าน props
// เพราะ <GlobalStyle /> ถูกวางไว้นอก <ThemeProvider> ใน App.js
const { COLORS } = theme;

export const GlobalStyle = createGlobalStyle`
  /* ===== react-toastify ให้เข้าธีมแอป ===== */
  :root {
    --toastify-color-light: ${COLORS.WHITE_1};
    --toastify-text-color-light: ${COLORS.PURPLE_1};
    --toastify-color-success: ${COLORS.GREEN_2};
    --toastify-color-error: ${COLORS.RED_2};
    --toastify-color-warning: ${COLORS.ORANGE_1};
    --toastify-color-info: ${COLORS.PURPLE_1};
    --toastify-icon-color-success: ${COLORS.GREEN_2};
    --toastify-icon-color-error: ${COLORS.RED_2};
    --toastify-icon-color-warning: ${COLORS.ORANGE_1};
    --toastify-icon-color-info: ${COLORS.PURPLE_1};
    --toastify-color-progress-success: ${COLORS.GREEN_2};
    --toastify-color-progress-error: ${COLORS.RED_2};
    --toastify-color-progress-warning: ${COLORS.ORANGE_1};
    --toastify-color-progress-info: ${COLORS.PURPLE_1};
    --toastify-font-family: prompt_medium;
    --toastify-toast-min-height: 56px;
  }

  /* การ์ดขอบมนขอบม่วง ให้เข้าชุดกับกล่องข้อมูลในแอป */
  .Toastify__toast {
    padding: 12px 14px;
    margin-bottom: 10px;
    border-radius: 12px;
    border: 1px solid ${COLORS.PURPLE_1};
    box-shadow: 0px 4px 16px rgba(75, 30, 120, 0.18);
    font-size: ${theme.FONT.SIZE.S15};
    line-height: 1.45;
  }
  .Toastify__toast--success {
    border-color: ${COLORS.GREEN_2};
  }
  .Toastify__toast--error {
    border-color: ${COLORS.RED_2};
  }
  .Toastify__toast--warning {
    border-color: ${COLORS.ORANGE_1};
  }
  .Toastify__toast-body {
    margin: 0;
    padding: 0;
    align-items: center;
  }
  .Toastify__toast-icon {
    width: 20px;
    margin-inline-end: 10px;
  }
  .Toastify__close-button {
    align-self: center;
    color: ${COLORS.PURPLE_1};
    opacity: 0.5;
    &:hover {
      opacity: 1;
    }
  }
  .Toastify__progress-bar {
    height: 3px;
  }

  /* default ของ lib บนจอเล็กคือกว้างเต็มจอ ชิดขอบบน ทำให้ขอบมนหายไปหมด */
  @media only screen and (max-width: 480px) {
    .Toastify__toast-container {
      width: calc(100% - 24px);
      left: 12px;
      right: 12px;
      padding: 0;
    }
    .Toastify__toast-container--top-left,
    .Toastify__toast-container--top-center,
    .Toastify__toast-container--top-right {
      top: 12px;
    }
    .Toastify__toast-container--bottom-left,
    .Toastify__toast-container--bottom-center,
    .Toastify__toast-container--bottom-right {
      bottom: 12px;
    }
  }

  html {
    body {
      margin: 0;
      padding: 0;
      position: relative;
      font-family: prompt_regular;
      font-size: 16px;
      color: #000000;
    }
     button {
      border: none; 
      &:focus {
        outline: none;
      }
    }
    input {
      &:focus {
        outline: none;
      }
    }
    textarea {
      &:focus {
        outline: none;
      }
    }
    img {
      display: block;
    }
    svg {
      display: block;
    }
  }
`;
